<div class="button-group">
  @for (square of squares; track i; let i = $index) {
  <button class="btn btn-light" [class.selected]="selectedSize() === i" (click)="handleClick(i)">
    @for(el of square; track j; let j = $index){
    <div></div>
    }
  </button>
  }
</div>
